<template>
    <div class="wizard__wrap">
        <div class="wizard__block">
            <div v-if="dashboard_data">
                <div class="row">
                    <div class="logo logo--after">
                        {{ dashboard_data.agency_name }}
                    </div>
                </div>

                <div class="wizard__block-title">
                    {{ dashboard_data.agency_name }}'s action plan for
                    {{ currentMonth }}
                </div>

                <div class="wizard__block-tasks">
                    <div class="row" v-for="task in dashboard_data.page">
                        <div class="task">
                            <div class="title" v-html="task.title"></div>
                            <div class="list">
                                <p
                                    v-for="subtask in task.data"
                                    :key="subtask.name + subtask.id"
                                >
                                    <template v-if="subtask.type === 'kickoff'">
                                        Deal:
                                        <span>{{ subtask.name }}</span> Service:
                                        <span>{{ subtask.services }}</span>
                                    </template>
                                    <template v-else>
                                        {{ subtask.type }}
                                        <span>
                                            {{ subtask.name
                                            }}<span
                                                style="color: black"
                                                v-if="subtask.type == 'Invoice'"
                                                >: ${{ subtask.amount }}</span
                                            >
                                        </span>
                                    </template>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wizard__block-footer">
                    <div class="row jus-c--center">
                        <button @click="handleOnGo" class="btn btn-white">
                            GO
                        </button>
                    </div>
                </div>
            </div>

            <div v-else-if="!dashboard_data && !isLoading">
                <div class="row" style="justify-content: center">
                    <div class="wizard__block-title">
                        No agency is associated with your account. <br />Please
                        contact the administrator
                    </div>
                </div>
            </div>

            <div class="loader" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader";
import axios from "axios";
import moment from "moment";
import { SECTIONS } from "../consts";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_Dashboard",
    props: ["onGo", "toEditSales", "onHandleUploadLater"],
    components: {
        ClipLoader,
    },
    data() {
        return {
            isLoading: false,
            dashboard_data: null,
            isHasKickOff: false,
            isHasUploadLaterSOWs: false,
        };
    },
    mounted() {
        this.getTasks();

        scrollToTop();
    },
    computed: {
        currentMonth: () => {
            return moment().format("MMMM'YY");
        },
    },
    methods: {
        handleOnGo() {
            if (this.isHasUploadLaterSOWs) {
                this.onHandleUploadLater();
            } else if (this.isHasKickOff) {
                this.onGo();
            } else {
                this.toEditSales();
            }
        },
        async getTasks() {
            try {
                this.isLoading = true;

                await axios
                    .post("/api/wizard/getList", { page: "dashboard" })
                    .then((res) => {
                        const { data } = res;

                        if (
                            typeof data === "object" &&
                            !Array.isArray(data) &&
                            data !== null
                        ) {
                            this.dashboard_data = data;
                            this.$store.commit(
                                "setAgencyName",
                                data.agency_name
                            );

                            if (!data.page.length) {
                                this.$store.commit(
                                    "setCurrentSection",
                                    SECTIONS.NO_ACTIONS
                                );
                            }

                            return;
                        }

                        this.dashboard_data = null;
                    })
                    .finally(() => {
                        this.checkIfHasKickOffDeals();
                        this.checkIfHasUploadLaterSOWs();
                        this.isLoading = false;
                    });
            } catch (err) {
                console.error(err);
            }
        },
        async checkIfHasKickOffDeals() {
            await axios
                .post("/api/wizard/getList", {
                    page: "edit_upsell",
                })
                .then((res) => {
                    if (Object.values(res.data.page.deals).length > 0) {
                        this.isHasKickOff = true;
                        this.$store.commit("setIsHasKickOff", true);
                    } else {
                        this.$store.commit("setIsHasKickOff", false);
                    }
                })
                .catch((err) => console.log("err getData upsell", err));
        },

        async checkIfHasUploadLaterSOWs() {
            await axios
                .post("/api/wizard/getList", {
                    page: "get_upload_later",
                })
                .then((res) => {
                    if (Object.values(res.data.page).length > 0) {
                        this.isHasUploadLaterSOWs = true;
                        this.$store.commit("setIsHasUploadLaterSOWs", true);
                    } else {
                        this.$store.commit("setIsHasUploadLaterSOWs", false);
                    }
                })
                .catch((err) => console.log("err getData upload later", err));
        },
    },
};
</script>
